import _createForOfIteratorHelper from "/home/runner/work/mozio-web/mozio-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper.js";
import _regeneratorRuntime from "/home/runner/work/mozio-web/mozio-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator/index.js";
import $kIQ5E$react from "react";
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */

function $1cd244557c2f97d5$var$Column(props) {
  return null;
}

$1cd244557c2f97d5$var$Column.getCollectionNode = /*#__PURE__*/_regeneratorRuntime.mark(function getCollectionNode(props, context) {
  var title, children, childColumns, rendered, textValue, fullNodes, updateContext;
  return _regeneratorRuntime.wrap(function getCollectionNode$(_context2) {
    while (1) switch (_context2.prev = _context2.next) {
      case 0:
        title = props.title, children = props.children, childColumns = props.childColumns;
        rendered = title || children;
        textValue = props.textValue || (typeof rendered === 'string' ? rendered : '') || props['aria-label'];
        _context2.next = 5;
        return {
          type: 'column',
          hasChildNodes: !!childColumns || !!title && (0, $kIQ5E$react).Children.count(children) > 0,
          rendered: rendered,
          textValue: textValue,
          props: props,
          childNodes: /*#__PURE__*/_regeneratorRuntime.mark(function childNodes() {
            var _iterator, _step, child, _childColumns;

            return _regeneratorRuntime.wrap(function childNodes$(_context) {
              while (1) switch (_context.prev = _context.next) {
                case 0:
                  if (!childColumns) {
                    _context.next = 20;
                    break;
                  }

                  _iterator = _createForOfIteratorHelper(childColumns);
                  _context.prev = 2;

                  _iterator.s();

                case 4:
                  if ((_step = _iterator.n()).done) {
                    _context.next = 10;
                    break;
                  }

                  child = _step.value;
                  _context.next = 8;
                  return {
                    type: 'column',
                    value: child
                  };

                case 8:
                  _context.next = 4;
                  break;

                case 10:
                  _context.next = 15;
                  break;

                case 12:
                  _context.prev = 12;
                  _context.t0 = _context["catch"](2);

                  _iterator.e(_context.t0);

                case 15:
                  _context.prev = 15;

                  _iterator.f();

                  return _context.finish(15);

                case 18:
                  _context.next = 24;
                  break;

                case 20:
                  if (!title) {
                    _context.next = 24;
                    break;
                  }

                  _childColumns = [];
                  (0, $kIQ5E$react).Children.forEach(children, function (child) {
                    _childColumns.push({
                      type: 'column',
                      element: child
                    });
                  });
                  return _context.delegateYield(_childColumns, "t1", 24);

                case 24:
                case "end":
                  return _context.stop();
              }
            }, childNodes, null, [[2, 12, 15, 18]]);
          }),
          shouldInvalidate: function shouldInvalidate(newContext) {
            // This is a bit of a hack, but it works.
            // If this method is called, then there's a cached version of this node available.
            // But, we need to keep the list of columns in the new context up to date.
            updateContext(newContext);
            return false;
          }
        };

      case 5:
        fullNodes = _context2.sent;

        updateContext = function updateContext(context) {
          // register leaf columns on the context so that <Row> can access them
          var _iterator2 = _createForOfIteratorHelper(fullNodes),
              _step2;

          try {
            for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
              var node = _step2.value;
              if (!node.hasChildNodes) context.columns.push(node);
            }
          } catch (err) {
            _iterator2.e(err);
          } finally {
            _iterator2.f();
          }
        };

        updateContext(context);

      case 8:
      case "end":
        return _context2.stop();
    }
  }, getCollectionNode);
});
/**
 * A Column represents a field of each item within a Table. Columns may also contain nested
 * Column elements to represent column groups. Nested columns can be statically defined as
 * children, or dynamically generated using a function based on the `childColumns` prop.
 */
// We don't want getCollectionNode to show up in the type definition

var $1cd244557c2f97d5$export$816b5d811295e6bc = $1cd244557c2f97d5$var$Column;
export { $1cd244557c2f97d5$export$816b5d811295e6bc as Column };